import styled from 'styled-components';

type BullersProps = {
  bulletAmount?: number;
  className?: string;
};
const Bullets: React.FC<BullersProps> = ({ bulletAmount = 1, className }) => {
  return (
    <Container>
      {Array.from({ length: bulletAmount }).map((_, index) => (
        <Bullet key={index} className={className} />
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
`;
const Bullet = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  width: 1.4rem;
  height: 1.4rem;
  background-color: ${({ theme }) => theme.colors.text.secondary};
  margin-right: 0.6rem;
  &:last-child {
    margin-right: 0;
  }
`;
export default Bullets;
